import React, {useState, useEffect} from 'react';
import {useParams, withRouter} from "react-router-dom";
import {Col, Container, Row} from "reactstrap";
import {loginApi, shopifyAuthApi} from "../services/auth";
import {toast} from "react-toastify";
import {setUserDataPassportAuth} from "../redux/auth/userSlice";
import {getUserMenus} from "../redux/auth/navigationSlice";
import {useDispatch} from "react-redux";
import PreLoader from "../share-components/ui/preLoader";

const ShopifyAuth = () => {
    const {token} = useParams()
    const dispatch = useDispatch();
    const [loading,setLoading] = useState(true);
    useEffect(async () => {

        const params = {
              token: token,
          }
        await shopifyAuthApi(params)
            .then(data => {
                localStorage.setItem('token', data.response.accessToken);
                localStorage.setItem('shopify_domain',data.response.shopify_domain);
                // window.location.href = `${process.env.PUBLIC_URL}/dashboard/default/`

                     toast.success("Successfully Logged in !");
                     dispatch(setUserDataPassportAuth(data.response.user));
                     dispatch(getUserMenus());
                     setLoading(false);


            })
            .catch(error => {
                toast.error("error");
            });
    },[])
    return (
          <Container fluid={true} className="p-0">
              {loading? <PreLoader></PreLoader>: <Row>
                <Col xs="12">
                    <div className="login-card">
                        <div>
                            <div>
                                <a className="logo" href="index.html">
                                    <img className="img-fluid for-dark"
                                         src={require("../assets/images/logo/logo_dark.png")} alt=""/>
                                </a>
                            </div>
                            <div className="login-main login-tab">
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>}
        </Container>
    )
}

export default withRouter(ShopifyAuth);